<template>
  <div class="section">
    <div class="container">
      <Permissions>
        <h1 class="title">{{ $t("dashboardTitle") }} - {{ $store.getters.getOrganizationName }}</h1>
        <div class="subtitle is-5">{{ $t("customerId") }}: {{ $store.getters.getOrganizationId }}</div>
        <DashboardTabs v-if="!reload" />
      </Permissions>
    </div>
  </div>
</template>

<script>
import DashboardTabs from "@/components/DashboardTabs.vue";
import Permissions from "@/components/Permissions.vue";

export default {
  name: "Dashboard",
  components: {
    DashboardTabs,
    Permissions,
  },
  data() {
    return {
      reload: false,
    };
  },
  created() {
    window.store = this.$store;
    this.$watch(
      () => this.$store.state.organizationId,
      () => {
        this.reload = true;
        setTimeout(() => {
          this.reload = false;
        }, 10);
      },
    );
  },
};
</script>
